import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { serviceDiscoveryApi } from 'services/apiDigitalTicket/serviceDiscovery';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';
import * as ServiceDiscoveryActions from './actions';

// Types
import { ServiceDiscoveryTypes } from './types';

function* list({
  payload,
}: ReturnType<
  typeof ServiceDiscoveryActions.listServiceDiscoveryRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Carregando parâmetros' }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(serviceDiscoveryApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        ServiceDiscoveryActions.listServiceDiscoverySuccess({
          serviceDiscoveryList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('serviceDiscovery - listServiceDiscovery - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(ServiceDiscoveryActions.listServiceDiscoveryFailure());
    yield put(DialogsActions.setClose());
  }
}

function* update({
  payload,
}: ReturnType<
  typeof ServiceDiscoveryActions.updateServiceDiscoveryRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Atualizando parâmetros' }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(serviceDiscoveryApi.update, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        ServiceDiscoveryActions.updateServiceDiscoverySuccess({
          serviceDiscoveryData: response.data,
        }),
      );
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Parâmetros atualizados com sucesso',
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('serviceDiscovery - updateServiceDiscovery - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(ServiceDiscoveryActions.updateServiceDiscoveryFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const serviceDiscoverySagas = [
  takeLatest(ServiceDiscoveryTypes.LIST_SERVICE_DISCOVERY_REQUEST, list),
  takeLatest(ServiceDiscoveryTypes.UPDATE_SERVICE_DISCOVERY_REQUEST, update),
];
